// Mining and Resources inner page — Industries tile 01.
import { ArrowRight } from "lucide-react";
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import InnerHero from "../../components/InnerHero";
import Reveal from "../../components/Reveal";
import { VIDEOS } from "../../lib/media";

export default function Mining() {
  return (
    <div className="bg-black">
      <Nav route="inner" />
      <InnerHero
        video={VIDEOS.mining}
        eyebrow="Industries · Mining and Resources"
        headline="AI built for the"
        italicWord="Pilbara."
        lede="We build AI systems that work in the heat, the dust and the shift patterns of Australian mining operations."
      />

      <section className="bg-black py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6">

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">What we build</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              From dispatch to ore grade, AI where it moves the needle.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              Predictive maintenance systems that catch equipment failures before they cause unplanned
              downtime. AI dispatch copilots that optimise load and haul cycles across your fleet.
              Computer vision QA on conveyor lines and processing plant.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              Ore-grade prediction from drill data. Autonomous reporting for environmental and safety
              obligations. We have built production systems across all of these use cases.
            </p>
          </Reveal>

          <div className="hairline my-16" />

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">How we work with mining clients</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              We learn your operation before we write a line of code.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              Mining AI fails when it is built from a distance. We spend time on site, with your
              operators and your maintenance crews, understanding the real constraints before we
              design a system.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              We work with your existing SCADA, telematics and plant management systems. We do not
              require a full technology replacement. We build on what you have and add AI where it
              creates measurable value.
            </p>
          </Reveal>

          <div className="hairline my-16" />

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">Right for you if</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              You run fleet or plant operations in WA or NZ.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              You have telematics data you are not fully using. You want to move from break-fix
              maintenance to condition-based maintenance without a multi-year ERP implementation.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              You need AI that can operate in a low-connectivity, high-temperature, safety-critical
              environment. Not a cloud dashboard that breaks when the network drops out.
            </p>
          </Reveal>

        </div>
      </section>

      <section className="bg-black px-6 pb-24">
        <div className="max-w-2xl mx-auto liquid-glass rounded-3xl p-10 text-center">
          <h3 className="font-instrument text-3xl text-white">Ready to build something that lasts?</h3>
          <p className="text-white/60 text-base mt-4">
            Start with a 30-minute discovery call. No slide deck. Just an engineer.
          </p>
          <a
            href="/#contact"
            className="mt-8 inline-flex items-center gap-2 rounded-full px-8 py-3 bg-white text-black text-sm font-medium hover:bg-white/90 transition-colors"
          >
            Book a discovery <ArrowRight size={16} />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
